import React from "react";
import DashboardHomePage from "./components/DashboardHome";

export function DashboardHome(props) {
  const { t, ...rest } = props;
  return <DashboardHomePage {...rest} t={t} />;
}
